import ModalShell from './ModalShell';
import { buildInterviewRoundsFromCount } from '../constants/interviewRounds';

export default function InterviewRoundsConfigModal({
  open,
  roundCount,
  rounds,
  onChange,
  onClose,
  readOnly = false
}) {
  if (!open) return null;

  const list = buildInterviewRoundsFromCount(roundCount, rounds);

  return (
    <ModalShell
      title={readOnly ? 'Interview rounds' : 'Configure interview rounds'}
      subtitle={`${roundCount} round${roundCount === 1 ? '' : 's'} for this job`}
      onClose={onClose}
      maxWidth="max-w-md"
      footer={
        <button type="button" className="px-4 py-2 text-sm border border-[hsl(var(--ds-border))]" onClick={onClose}>
          {readOnly ? 'Close' : 'Done'}
        </button>
      }
    >
      <ol className="space-y-3">
        {list.map((round, idx) => (
          <li key={round.id || idx} className="flex gap-2 items-end">
            <span className="text-xs text-[hsl(var(--ds-muted-fg))] w-6 pb-2 shrink-0">{idx + 1}.</span>
            {readOnly ? (
              <p className="text-sm font-medium text-[hsl(var(--ds-fg))] py-2">{round.name}</p>
            ) : (
              <div className="field-with-label flex-1">
                <input
                  className="h-9 w-full rounded-xl border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] px-3 text-sm text-[hsl(var(--ds-fg))] outline-none hover:border-[hsl(var(--ds-primary)/0.45)] focus:border-[hsl(var(--ds-primary))] focus:ring-2 focus:ring-[hsl(var(--ds-ring))]"
                  value={round.name}
                  onChange={e => {
                    const next = [...list];
                    next[idx] = { ...next[idx], name: e.target.value };
                    onChange(next);
                  }}
                  placeholder=" "
                />
                <label>Round name</label>
              </div>
            )}
          </li>
        ))}
      </ol>
    </ModalShell>
  );
}
